export class RemoveImplementModalData {
    public implementId: number;
    public jobsiteId: number;
    public equipmentId: number;
    public smu: number;
    public cost: number;
    public date: Date;
    public comment: string;
    public status: number;
    public repairerId: number;
    public workshopId: number;
}